import { timestampCodec } from "../../validation/codecs";
import { mixed, optional, required, t } from "../../validation/validator";
import { CallResponseSchema } from "../common/callResponseSchema";

const commonUserFields = {
  email: t.string,
  rating: t.number,
  first_name: t.string,
  last_name: t.string,
  gender: t.string,
  avatar: t.union([t.string, t.null]),
  country_code: t.union([t.string, t.null]),
  updated_at: t.union([timestampCodec, t.undefined, t.null]),
  birth_date: t.union([timestampCodec, t.undefined, t.null]),
};

export const UserRecordSchema = t.type({
  id: t.number,
  doc_id: t.string,
  created_at: timestampCodec,
  last_active_at: t.union([timestampCodec, t.undefined, t.null]),
  profile_allowance: t.union([t.number, t.undefined, t.null]),
  auth_id: t.union([t.string, t.undefined, t.null]),
  ...commonUserFields,
});

export type UserRecord = t.TypeOf<typeof UserRecordSchema>;

export const UpdateUserSchema = optional({
  user_doc_id: t.string,
  user_id: t.number,
  ...commonUserFields,
});

export const GetUserRequestSchema = optional({
  user_doc_id: t.string,
  user_id: t.number,
  user_auth_id: t.string,
  user_email: t.string,
});

export type GetUserRequest = t.TypeOf<typeof GetUserRequestSchema>;

export const CreateUserRecordSchema = optional({
  doc_id: t.string,
});

// Preferences may contain booleans, slider values, or a locale string.
export const PreferenceValueSchema = t.union([t.boolean, t.number, t.string, t.null]);
export const GetPreferencesRequestSchema = t.type({ action: t.literal("REQUEST") });
export const UserPreferencesSchema = t.record(t.string, PreferenceValueSchema);
export const PreferenceUpdateSchema = t.type({ id: t.string, value: PreferenceValueSchema });
export const UpdatePreferencesRequestSchema = t.type({
  action: t.literal("UPDATE"),
  preferences: t.array(PreferenceUpdateSchema),
});
export const UpdatePreferencesResponseSchema = t.type({ code: t.string, message: t.string });
export type UserPreferences = t.TypeOf<typeof UserPreferencesSchema>;
export type PreferenceUpdate = t.TypeOf<typeof PreferenceUpdateSchema>;
export type UpdatePreferencesRequest = t.TypeOf<typeof UpdatePreferencesRequestSchema>;
export type UpdatePreferencesResponse = t.TypeOf<typeof UpdatePreferencesResponseSchema>;

// Client API
export const UserApis = {
  Users: {
    GetPreferences: {
      Name: "users-preferences",
      Request: GetPreferencesRequestSchema,
      Response: UserPreferencesSchema,
    },
    UpdatePreferences: {
      Name: "users-preferences",
      Request: UpdatePreferencesRequestSchema,
      Response: UpdatePreferencesResponseSchema,
    },
    UpdateUser: {
      Name: "users-updateUserV2",
      Request: UpdateUserSchema,
      Response: mixed([required({ data: UserRecordSchema }), CallResponseSchema]),
    },
    SkipBootcamp: {
      Name: "users-skipBootcamp",
      Request: required({}),
      Response: CallResponseSchema,
    },
    GetUser: {
      Name: "users-getUser",
      Request: GetUserRequestSchema,
      Response: UserRecordSchema,
    },
    CreateUserRecord: {
      Name: "users-createUserRecord",
      Request: CreateUserRecordSchema,
      Response: mixed([required({ data: UserRecordSchema }), CallResponseSchema]),
    },
  },
};
